import DateInput from './DateInput'

export default DateInput
